module.exports = __webpack_public_path__ + "static/media/technology_cn.45912833.png";